import _regeneratorRuntime from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.date.to-json.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue";
var _hoisted_1 = {
  class: "ae-page"
};
var _hoisted_2 = {
  class: "row"
};
var _hoisted_3 = {
  class: "row place-search-field"
};
var _hoisted_4 = {
  class: "row"
};
var _hoisted_5 = {
  class: "ae-bottom"
};
import { ref, computed, onMounted, nextTick } from "vue";
import { Toast, Search as VanSearch } from "vant";
import Button from "@/components/base/Button.vue";
import Input from "@/components/base/Input.vue";
import GoogleMapHelper from "@/utils/googleMapHelper";
import { useAddressStoreWithOut } from "@/store/addressStore";
import { useRouter } from "@/hooks/useRouter";
import Dialog from "@/components/dialog/dialog";
import { showToast } from "@/utils/toastUtil";
import { useUserStore } from "@/store/userStore";
import { hideLoading, showLoading } from "@/utils/loadingUtil";
import { useI18n } from "vue-i18n";
import { getCountry } from "../../utils/authUtil";
import { isFunction } from "@/utils/isUtil";
export default {
  __name: 'AddressEditUS',
  setup: function setup(__props) {
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var _useRouter = useRouter(),
      routerBack = _useRouter.routerBack,
      router = _useRouter.router,
      routerGo = _useRouter.routerGo;
    var addressStore = useAddressStoreWithOut();
    var userStore = useUserStore();

    // const handlePageBack = () => {
    //   // 如果地址列表长度为0,说明是连跳进来的,向上返回2级
    //   if (addressStore.getAddressList.length === 0) {
    //     routerGo(-2);
    //   } else {
    //     routerBack();
    //   }
    // };

    var selectedId = ref("");
    var searchValue = ref("");
    var addressDetail = ref({
      contact_name: "",
      // 姓名
      contact_number: "",
      // 电话
      // label: "", // label
      location: {
        coordinate: {
          longitude: 0,
          // 经度
          latitude: 0 // 纬度
        },
        map_location: "",
        // 地图位置
        detail: "" // 补充地址详情
      },
      notes: "" // 备注
    });
    var hasInitedMap = ref(false); // 是否已初始化地图
    var mapHelper = ref(null);
    var mapMarker = null;
    var isSaveAble = computed(function () {
      var addressDetailObj = addressDetail.value;
      return addressDetailObj.contact_name && addressDetailObj.contact_number && addressDetailObj.location.map_location
      // &&
      // addressDetailObj.label &&
      // addressDetailObj.location.detail
      ;
    });
    var getDeliveryDetail = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(coordinate, site) {
        var lat, lng, address, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              lat = isFunction(coordinate.lat) ? coordinate.lat() : coordinate.lat;
              lng = isFunction(coordinate.lng) ? coordinate.lng() : coordinate.lng;
              _context.next = 5;
              return mapHelper.value.reverseGeocoding({
                lat: lat,
                lng: lng
              });
            case 5:
              address = _context.sent;
              if (!address) {
                _context.next = 11;
                break;
              }
              res = {
                detail: "",
                map_location: address.formatted_address || "",
                coordinate: {
                  latitude: lat,
                  longitude: lng
                }
              };
              addressDetail.value.location = res;
              // 搜索框回显
              searchValue.value = res.map_location;
              return _context.abrupt("return", res);
            case 11:
              _context.next = 16;
              break;
            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](0);
              console.error("[getDeliveryDetail error]:", _context.t0);
            case 16:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 13]]);
      }));
      return function getDeliveryDetail(_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }();
    var handleMoveMarker = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(event) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return getDeliveryDetail(event.latLng);
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function handleMoveMarker(_x3) {
        return _ref2.apply(this, arguments);
      };
    }();
    var initAutocomplete = function initAutocomplete() {
      var mh = mapHelper.value;
      mh.initCustomAutocomplete("place-search", /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(place) {
          var res;
          return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                if (!(!place.address_components || !place.geometry)) {
                  _context3.next = 2;
                  break;
                }
                return _context3.abrupt("return");
              case 2:
                _context3.next = 4;
                return getDeliveryDetail(place.geometry.location, place.name);
              case 4:
                res = _context3.sent;
                if (res) {
                  if (!hasInitedMap.value) {
                    // 之前还没有创建地图,需要从头initMap
                    initMap({
                      lat: res.coordinate.latitude,
                      lng: res.coordinate.longitude
                    }).then(function () {
                      hasInitedMap.value = true;
                    }).catch(function (e) {
                      console.error(e);
                      showToast(t("loadGoogleMapServiceError"));
                    });
                  } else {
                    // 已创建地图的情况,直接setCenter即可
                    mapHelper.value.setCenter({
                      lat: res.coordinate.latitude,
                      lng: res.coordinate.longitude
                    });
                    if (mapHelper.value) {
                      // 已有marker
                      mapHelper.value.removeMarker(mapMarker);
                    }
                    mapMarker = mapHelper.value.addMarker({
                      lat: res.coordinate.latitude,
                      lng: res.coordinate.longitude
                    }, {
                      draggable: true
                    });
                    google.maps.event.addListener(mapMarker, "dragend", handleMoveMarker);
                  }
                }
              case 6:
              case "end":
                return _context3.stop();
            }
          }, _callee3);
        }));
        return function (_x4) {
          return _ref3.apply(this, arguments);
        };
      }(), "van-field__value");
    };
    var handleUseCurCoordinate = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var coordinate, res;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              showLoading();
              _context4.next = 3;
              return mapHelper.value.getCurrentPositionByH5();
            case 3:
              res = _context4.sent;
              if (res.isOK && res.data) {
                userStore.setCoordinate(res.data);
                coordinate = userStore.getCoordinate;
              } else if (userStore.getCoordinate) {
                coordinate = userStore.getCoordinate;
              }
              if (!coordinate) {
                _context4.next = 11;
                break;
              }
              // 根据坐标设置地图
              if (!hasInitedMap.value) {
                // 之前还没有创建地图,需要从头initMap
                initMap({
                  lat: coordinate.lat,
                  lng: coordinate.lng
                }).then(function () {
                  hasInitedMap.value = true;
                }).catch(function (e) {
                  showToast(t("loadGoogleMapServiceError"));
                });
              } else {
                // 已创建地图的情况,直接setCenter即可
                mapHelper.value.setCenter({
                  lat: coordinate.lat,
                  lng: coordinate.lng
                });
                if (mapHelper.value) {
                  // 已有marker
                  mapHelper.value.removeMarker(mapMarker);
                }
                mapMarker = mapHelper.value.addMarker({
                  lat: coordinate.lat,
                  lng: coordinate.lng
                }, {
                  draggable: true
                });
                google.maps.event.addListener(mapMarker, "dragend", handleMoveMarker);
              }
              // 填充地址详情
              _context4.next = 9;
              return getDeliveryDetail(coordinate);
            case 9:
              _context4.next = 12;
              break;
            case 11:
              showToast(t("failedToGetLocation"));
            case 12:
              hideLoading();
            case 13:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      return function handleUseCurCoordinate() {
        return _ref4.apply(this, arguments);
      };
    }();
    var initMap = function initMap(coordinate) {
      return new Promise(function (resolve, reject) {
        mapHelper.value.initMap("map", {
          center: coordinate,
          zoom: 12,
          disableDefaultUI: true
        }, function (e) {
          if (e) {
            reject(e);
            return;
          }
          if (mapHelper.value) {
            // 已有marker
            mapHelper.value.removeMarker(mapMarker);
          }
          mapMarker = mapHelper.value.addMarker({
            lat: coordinate.lat,
            lng: coordinate.lng
          }, {
            draggable: true
          });
          google.maps.event.addListener(mapMarker, "dragend", handleMoveMarker);
          resolve(true);
        });
      });
    };
    var handleUpdateContactNumber = function handleUpdateContactNumber(val) {
      addressDetail.value.contact_number = val;
      nextTick(function () {
        var value = addressDetail.value.contact_number;
        // 过滤非法字符
        value = value.replace(/[\D]/g, "");
        addressDetail.value.contact_number = value;
      });
    };
    var validator = function validator() {
      if (addressDetail.value.contact_number.length < 7) {
        showToast(t("pleaseInputACorrectTelNumber"));
        return false;
      }
      return true;
    };
    var handleDisabledSave = function handleDisabledSave() {
      showToast(t("pleaseFillInTheCompleteAddressInformation"));
    };
    var handleSave = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (validator()) {
                _context5.next = 2;
                break;
              }
              return _context5.abrupt("return");
            case 2:
              showLoading();
              if (!selectedId.value) {
                _context5.next = 8;
                break;
              }
              _context5.next = 6;
              return addressStore.updateAddress(addressDetail.value);
            case 6:
              _context5.next = 10;
              break;
            case 8:
              _context5.next = 10;
              return addressStore.addAddress(addressDetail.value);
            case 10:
              hideLoading();
              routerBack();
            case 12:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      return function handleSave() {
        return _ref5.apply(this, arguments);
      };
    }();
    var handleDelete = function handleDelete() {
      // addressStore.deleteAddress(selectedId.value);
      // routerBack();
      // test.value = true;
      Dialog.confirm({
        title: t("deleteThisAddress"),
        desc: t("areYouSureToDeleteThisAddress"),
        okText: t("yes"),
        onOk: function () {
          var _onOk = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
            return _regeneratorRuntime().wrap(function _callee6$(_context6) {
              while (1) switch (_context6.prev = _context6.next) {
                case 0:
                  showLoading();
                  _context6.next = 3;
                  return addressStore.deleteAddress(selectedId.value);
                case 3:
                  hideLoading();
                  routerBack();
                case 5:
                case "end":
                  return _context6.stop();
              }
            }, _callee6);
          }));
          function onOk() {
            return _onOk.apply(this, arguments);
          }
          return onOk;
        }(),
        cancelText: t("no")
      });
    };
    onMounted(function () {
      mapHelper.value = new GoogleMapHelper({
        countryCode: getCountry()
      });
      if (router.currentRoute.value.query) {
        var targetId = router.currentRoute.value.query.id || "";
        var targetAddress = addressStore.getAddressList.find(function (item) {
          return item.id === targetId;
        });
        if (targetAddress) {
          selectedId.value = targetId;
          addressDetail.value = JSON.parse(JSON.stringify(targetAddress));
          searchValue.value = targetAddress.location.map_location;
          initMap({
            lat: targetAddress.location.coordinate.latitude,
            lng: targetAddress.location.coordinate.longitude
          }).then(function () {
            initAutocomplete();
            hasInitedMap.value = true;
          }).catch(function (e) {
            console.error(e);
            showToast(t("loadGoogleMapServiceError"));
          });
        } else {
          handleUseCurCoordinate();
          mapHelper.value.initMap(undefined, undefined, function () {
            initAutocomplete();
          });
        }
      }
    });
    return function (_ctx, _cache) {
      var _component_Page = _resolveComponent("Page");
      return _openBlock(), _createBlock(_component_Page, {
        title: selectedId.value ? _ctx.$t('editAddress') : _ctx.$t('addNewAddress'),
        class: "ae-ctn-us",
        "show-footer": ""
      }, {
        footer: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_5, [_createVNode(Button, {
            disabled: !isSaveAble.value,
            class: "btn",
            onClick: handleSave,
            onDisabledClick: handleDisabledSave
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_ctx.$t("save")), 1)];
            }),
            _: 1
          }, 8, ["disabled"]), selectedId.value ? (_openBlock(), _createBlock(Button, {
            key: 0,
            type: "border",
            class: "btn",
            onClick: handleDelete
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_ctx.$t("deleteAddress")), 1)];
            }),
            _: 1
          })) : _createCommentVNode("", true)])];
        }),
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [_cache[3] || (_cache[3] = _createElementVNode("div", {
            id: "map",
            class: "ae-map",
            style: {
              "border-radius": "6px",
              "height": "254px",
              "background-color": "#45a57d"
            }
          }, null, -1)), _createElementVNode("div", _hoisted_2, [_createVNode(Input, {
            modelValue: addressDetail.value.contact_name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return addressDetail.value.contact_name = $event;
            }),
            class: "row-item-1d2",
            label: _ctx.$t('yourName'),
            required: "",
            placeholder: _ctx.$t('yourName')
          }, null, 8, ["modelValue", "label", "placeholder"]), _createVNode(Input, {
            "model-value": addressDetail.value.contact_number,
            class: "row-item-1d2",
            label: _ctx.$t('yourTel'),
            required: "",
            placeholder: _ctx.$t('yourTel'),
            "onUpdate:modelValue": handleUpdateContactNumber
          }, null, 8, ["model-value", "label", "placeholder"])]), _createElementVNode("div", _hoisted_3, [_createVNode(Input, {
            modelValue: searchValue.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
              return searchValue.value = $event;
            }),
            "field-id": "place-search",
            required: "",
            "allow-clear": "",
            label: _ctx.$t('location'),
            placeholder: _ctx.$t('location')
          }, null, 8, ["modelValue", "label", "placeholder"])]), _createElementVNode("div", _hoisted_4, [_createVNode(Input, {
            modelValue: addressDetail.value.location.detail,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
              return addressDetail.value.location.detail = $event;
            }),
            label: _ctx.$t('detailAddressOptional'),
            placeholder: _ctx.$t('detailAddressOptional')
          }, null, 8, ["modelValue", "label", "placeholder"])])])];
        }),
        _: 1
      }, 8, ["title"]);
    };
  }
};